import classnames from 'classnames';
import { Json } from '../../types';
import Palette from '../Palette/Palette';
import { Item, Title, Wrapper } from './Palettes.style';

export type PalettesProps = {
  palettes: IPalette[];
  selectedId: string;
  onSelectPalette: (paletteId: string) => void;
  onRestorePalette: () => void;
};

export function Palettes(props: PalettesProps) {
  const { palettes, selectedId } = props;

  function onMouseOver(palette: Json) {
    // TODO: set palette
  }

  function onClick(palette: Json) {
    // TODO: set palette

    // copy id to clipboard
    // navigator.clipboard.writeText(palette.id);
    props.onSelectPalette(palette.id);
  }

  function onBlur() {
    props.onRestorePalette();
  }

  function renderPalette(palette: IPalette) {
    const { name, materials } = palette;
    const tints = Object.values(materials).map((m: Json) => m.tint);

    const className = classnames('palette', {
      selected: selectedId === palette.id,
    });

    return (
      <Item
        key={palette.id}
        className={className}
        onMouseOver={() => onMouseOver(palette)}
        onClick={() => onClick(palette)}
      >
        <Title>{name}</Title>
        <Palette tints={tints} />
      </Item>
    );
  }

  function renderPalettes() {
    return palettes.map((palette: any) => renderPalette(palette));
  }

  return (
    <Wrapper className='Palettes-wrapper' data-testid='Palettes-wrapper' onMouseLeave={onBlur}>
      {renderPalettes()}
    </Wrapper>
  );
}

export default Palettes;
